import Axios from 'axios';
import { OrderCircle_CONFIG } from '@/js/config.js';
const RESOURCE_NAME = OrderCircle_CONFIG.API_URL + 'shop';

export default {
    getShop(pageNumber,pageSize,filter,sort,catfilter,product_collection_sort_check) {
        var pageURL;
        if(typeof pageNumber !== 'undefined'){  pageURL =`?page=`+pageNumber }
        if(typeof pageSize !== 'undefined'){  pageURL = pageURL + `&pageSize=`+pageSize }
        if(typeof filter !== 'undefined'){  pageURL = pageURL + `&filter=`+filter }
        if(typeof sort !== 'undefined'){ pageURL = pageURL + `&sort=`+sort }
        if(typeof catfilter !== 'undefined'){  pageURL = pageURL + `&catfilter=`+catfilter }
        if(typeof product_collection_sort_check !== 'undefined'){  pageURL = pageURL + `&product_collection_sort_check=`+product_collection_sort_check }
        return Axios.get(`${RESOURCE_NAME}`+pageURL);
    },
    addToCart(data,token) {
        return Axios.post(`${RESOURCE_NAME}/add-to-cart`, data);
    },
    get(id, token) {
        return Axios.get(`${RESOURCE_NAME}/${id}`);
    },

    edit(id, token) {
        return Axios.get(`${RESOURCE_NAME}/${id}/edit`);
    },

    create(data,token) {
        return Axios.post(RESOURCE_NAME, data);
    },

    update(id, data, token) {
        return Axios.put(`${RESOURCE_NAME}/${id}`, data);
    },

    delete(id, token) {
        return Axios.delete(`${RESOURCE_NAME}/${id}`);
    },
    getBrandInfo(token){
    return Axios.get(`${RESOURCE_NAME}/brand-info/customer`);        
    },
    clearShopCart(data, token){
        return Axios.put(`${RESOURCE_NAME}/clear-cart`, data);        
    },
    getCustomerCanCreateOrder(id, token){
        return Axios.get(`${RESOURCE_NAME}/customer-can-create-order/${id}`);
    },
};
